import { __require as y } from "../../../../../lodash.toarray@4.4.0/bundled_deps/lodash.toarray/index.js";
import { __require as C } from "./flatten.js";
import { __require as T } from "./for_each_object.js";
import { __require as D } from "./includes.js";
import { __require as N } from "./map_object.js";
import { __require as k } from "./filter_object.js";
import { __require as B } from "./values.js";
import { __require as L } from "./unique.js";
import { __require as P } from "./is_undefined.js";
import w from "./emoji.json.js";
var l, U;
function W() {
  if (U) return l;
  U = 1;
  var g = y(), S = C(), h = T(), p = D(), v = N(), F = k(), E = B(), j = L(), s = P(), O = function(e) {
    for (var i = [], r = 0, n = e.length, t, o, d, I; r < n; )
      d = e.charAt(r), t = e.charCodeAt(r++), t >= 55296 && t <= 56319 && r < n ? (I = e.charAt(r), o = e.charCodeAt(r++), (o & 64512) == 56320 ? i.push([d + I, ((t & 1023) << 10) + (o & 1023) + 65536]) : (i.push([d, t]), r--)) : i.push([d, t]);
    return i;
  }, c = "__ic_", _ = w, u = {};
  _.forEach(function(e, i) {
    e.forEach(function(r) {
      u[r.unicode] = {
        identifier: r.identifier,
        isEmojiBase: r.isEmojiBase,
        supportedTwemoji: r.supportedTwemoji,
        categoryIndex: i
      };
    });
  });
  var a = {
    ":-)": "😀",
    ":-D": "😃",
    ";-)": "😉",
    "}-)": "👿",
    ":-o": "😮",
    ":-O": "😮",
    ":-/": "😕",
    ":-\\": "😕",
    "x-(": "😩",
    "X-(": "😩",
    ":-(": "😞",
    "B-)": "😎",
    ":-p": "😛",
    ":-P": "😛",
    ":-@": "😠",
    ":-|": "😐",
    ":-$": "😳"
  };
  h(a, function(e, i) {
    u[e][c + "ascii"] = i;
  });
  var f = [
    /* Following rendered poorly by Chrome 41.0.2272.118 */
    "⁉",
    "⁉️",
    "‼️",
    "✂",
    "✈",
    "✉",
    "❤",
    "✌",
    "✏",
    "⚠",
    "🈷",
    "🈂",
    "Ⓜ",
    "Ⓜ️",
    "✒",
    "✔",
    "✖",
    "◼",
    "◻",
    "™",
    "☀",
    "☁",
    "♠",
    "♠️",
    "♣",
    "♣️",
    "♥",
    "♥️",
    "♦",
    "♦️",
    "♨",
    "▪",
    "▫",
    "ℹ",
    "↔",
    "↔️",
    "↕",
    "↖",
    "↖️",
    "↗",
    "↗️",
    "↘",
    "↘️",
    "↙",
    "↙️",
    "☑",
    "〰",
    "♻",
    "〽",
    "▶",
    "▶️",
    "☝",
    "✳",
    "✴",
    "❄",
    "❇",
    "⬆",
    "⬇",
    "⬅",
    "➡",
    "◀",
    "◀️",
    "↩",
    "↪",
    "⤴",
    "⤴️",
    "⤵",
    "⤵️",
    "㊗",
    "㊙",
    "☺",
    "☺️",
    "☹️",
    "☹",
    "‼",
    "🅰",
    "🅰️",
    "🅱",
    "🅱️",
    "🅿",
    "🅿️",
    "🅾",
    "🅾️",
    "🇯",
    "🇰",
    "🇩",
    "🇨",
    "🇺",
    "🇫",
    "🇪",
    "🇮",
    "🇷",
    "🇬",
    /* Following rendered poorly by Firefox 36.0.4 */
    "☔",
    "⭐",
    "⚡",
    "☕",
    "☎",
    "⚓",
    "♈",
    "♉",
    "♐",
    "♑",
    "♒",
    "♓",
    "♿",
    "♊",
    "♋",
    "♌",
    "♍",
    "♎",
    "♏",
    "◾",
    "◽",
    "⚫",
    "⚪"
  ], m = {};
  h(u, function(e, i) {
    m[c + e.identifier] = i;
  });
  var b = 10, A = _.map(function(e) {
    return e.map(function(i) {
      return i.unicode;
    });
  }), q = function(e, i, r) {
    for (var n = [], t = 0, o = 0; t + r <= i.length; ) {
      var d = i.slice(t, t + r);
      e.isSupportedAscii(d) && x(i, t - 1, t + r) ? (o < t && n.push(i.slice(o, t)), n.push(d), t += r, o = t) : ++t;
    }
    return o < i.length && n.push(i.slice(o, i.length)), n;
  }, x = function(e, i, r) {
    var n = !1, t = !1;
    return (i < 0 || /\s/.test(e.charAt(i))) && (n = !0), (r >= e.length || /\s/.test(e.charAt(r))) && (t = !0), n && t;
  };
  return l = {
    getGroupRepresentatives: function() {
      return [
        ["😄", "Smileys & Emotion"],
        ["👋", "People & Body"],
        ["🏻", "Component"],
        ["🌸", "Animals & Nature"],
        ["🍇", "Food & Drink"],
        ["🌍", "Travel & Places"],
        ["🎈", "Activities"],
        ["🔔", "Objects"],
        ["🔠", "Symbols"],
        ["🇮🇪", "Flags"]
      ];
    },
    getUglyNativeEmoji: function() {
      return f.slice();
    },
    isUglyNativeEmoji: function(e) {
      return p(f, e);
    },
    hasNativeSupport: function(e) {
      var i, r = "😀";
      if (!e.createElement("canvas").getContext || (i = e.createElement("canvas").getContext("2d"), typeof i.fillText != "function"))
        return !1;
      i.textBaseline = "top", i.font = "32px Arial", i.fillText(r, 0, 0);
      var n = i.getImageData(16, 16, 1, 1);
      return n ? n.data[0] !== 0 : !1;
    },
    isSupportedUnicode: function(e) {
      return u.hasOwnProperty(e);
    },
    isEmojiBaseUnicode: function(e) {
      return u[e].isEmojiBase;
    },
    identifierFromUnicode: function(e) {
      return u[e].identifier;
    },
    asciiFromUnicode: function(e) {
      return u[e][c + "ascii"];
    },
    groupFromUnicode: function(e) {
      return u[e].categoryIndex;
    },
    isSupportedAscii: function(e) {
      return a.hasOwnProperty(e);
    },
    unicodeFromAscii: function(e) {
      return a[e];
    },
    isSupportedIdentifier: function(e) {
      return m.hasOwnProperty(c + e);
    },
    unicodeFromIdentifier: function(e) {
      return m[c + e];
    },
    N_GROUPS: b,
    prettyEmoticonsUnicodeGroups: function() {
      return A.map(function(e) {
        return e.filter(function(i) {
          if (!p(f, i))
            return i;
        });
      });
    },
    allEmoticonsUnicodeGroups: A,
    allEmoticonsUnicodeList: Object.keys(u),
    allEmoticonsIdentifierList: v(u, function(e, i) {
      return e.identifier;
    }),
    prettyEmoticonsIdentifierList: function() {
      return v(
        F(
          u,
          function(e, i) {
            return !p(f, i) && e.isEmojiBase;
          }
        ),
        function(e, i) {
          return e.identifier;
        }
      );
    },
    asciiEmoticonsUnicodeList: j(E(a)),
    asciiEmoticonsIdentifierList: j(E(a)).map(function(e) {
      return u[e].identifier;
    }),
    MIN_ASCII_LENGTH: 3,
    MAX_ASCII_LENGTH: 3,
    // To allow for speed up splitOnAsciiEmojis
    asciiEmoticonsAsciiList: Object.keys(a),
    splitOnUnicodeEmojis: function(e) {
      if (s(e))
        return [];
      var i = g(e), r = [], n = !0;
      return i.forEach((function(t) {
        if (this.isSupportedUnicode(t))
          r.push(t), n = !0;
        else {
          if (n)
            r.push(t);
          else {
            var o = r.pop();
            r.push(o + t);
          }
          n = !1;
        }
      }).bind(this)), r;
    },
    splitOnAsciiEmojis: function(e) {
      if (s(e))
        return [];
      for (var i = [e], r = this.MAX_ASCII_LENGTH; r >= this.MIN_ASCII_LENGTH; --r) {
        for (var n = [], t = 0; t < i.length; ++t)
          n = n.concat(q(this, i[t], r));
        i = n;
      }
      return i;
    },
    getAllModifiedForBaseEmoji: function(e) {
      var i = [];
      if (e === "") return i;
      for (var r in u)
        r.indexOf(e) > -1 && i.push(r);
      return i;
    },
    splitOnUnicodeAndAsciiEmojis: function(e) {
      return s(e) ? [] : S(
        this.splitOnUnicodeEmojis(e).map((function(i) {
          return this.splitOnAsciiEmojis(i);
        }).bind(this))
      );
    },
    substituteUnicodeForAsciiEmojis: function(e) {
      return s(e) || e === null ? "" : this.splitOnAsciiEmojis(e).map((function(i) {
        return this.isSupportedAscii(i) ? this.unicodeFromAscii(i) : i;
      }).bind(this)).reduce(function(i, r) {
        return i + r;
      }, "");
    },
    wrapUnicodeEmojiInTitledSpans: function(e, i, r, n) {
      return s(i) ? "" : this.splitOnUnicodeEmojis(i).map((function(t) {
        if (this.isSupportedUnicode(t)) {
          if (this.isUglyNativeEmoji(t))
            return this.fallbackImage(e, t, r);
          var o = "";
          return n && (o = ' role="img" aria-label="' + this.identifierFromUnicode(t) + '"'), '<span title="' + this.identifierFromUnicode(t) + '"' + o + ">" + t + "</span>";
        } else
          return t;
      }).bind(this)).reduce(function(t, o) {
        return t + o;
      }, "");
    },
    substituteUnicodeForColonified: function(e) {
      for (var i = function(d) {
        return ":" + d + ":";
      }, r = !0, n = "", t = "", o = 0; o < e.length; o++)
        e[o] === ":" ? (r ? (r = !1, t += n) : (r = !0, t += this.isSupportedIdentifier(n) ? this.unicodeFromIdentifier(n) : i(n)), n = "") : n += e[o];
      return r || (t += ":"), t += n;
    },
    codepointIndexFromUnicode: function(e) {
      return O(e).map(function(i) {
        return i[1];
      });
    },
    fallbackImage: function(e, i, r) {
      return s(i) ? "" : this.splitOnUnicodeAndAsciiEmojis(i).map((function(n) {
        return this.isSupportedAscii(n) ? this.twemojiSpanTag(e, this.unicodeFromAscii(n), r) : this.isSupportedUnicode(n) ? this.twemojiSpanTag(e, n, r) : n;
      }).bind(this)).join("");
    },
    twemojiStyleString: function(e, i) {
      return "display:inline-block;height:" + e + "px;width:" + e + "px;background-image:url(" + this.twemojiSVGUri(i) + ");background-size:contain;";
    },
    twemojiSpanTag: function(e, i, r) {
      return s(r) && (r = "intermoji-default-class"), '<span style="' + this.twemojiStyleString(e, i) + '" title="' + this.identifierFromUnicode(i) + '" class="' + r + '" role="img" aria-label="' + this.identifierFromUnicode(i) + '"></span>';
    },
    twemojiSVGUri: function(e) {
      var i = this.getSupportedTwemoji(e), r = this.codepointIndexFromUnicode(i).map(function(t) {
        return t.toString(16);
      }), n = r.join("-").toLowerCase() + ".svg";
      return "https://js.intercomcdn.com/images/stickers/v2/svg/" + n;
    },
    getSupportedTwemoji: function(e) {
      return e in u && u[e].supportedTwemoji || e;
    },
    getEmojiFromSupportedTwemoji: function(e) {
      return Object.keys(u).find(function(i) {
        return u[i].supportedTwemoji === e;
      }) || e;
    }
  }, l;
}
export {
  W as __require
};
